import { render, staticRenderFns } from "./certificates-table-tool-bar.vue?vue&type=template&id=336256b9&scoped=true"
import script from "./certificates-table-tool-bar.vue?vue&type=script&lang=js"
export * from "./certificates-table-tool-bar.vue?vue&type=script&lang=js"
import style0 from "./certificates-table-tool-bar.vue?vue&type=style&index=0&id=336256b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336256b9",
  null
  
)

export default component.exports